import { render } from "./button.vue?vue&type=template&id=67d1b06c&scoped=true"
import script from "./button.vue?vue&type=script&lang=js"
export * from "./button.vue?vue&type=script&lang=js"

import "./button.vue?vue&type=style&index=0&id=67d1b06c&lang=scss"
import "./button.vue?vue&type=style&index=1&id=67d1b06c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67d1b06c"]])

export default __exports__